// extracted by mini-css-extract-plugin
export default {"input":"EditableTableDateCell_input__LZplZ"};